// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1fGwc","button":"button-1TsSI","on":"on-jRcZh","label":"label-1Y42m"};